import { SyntheticEvent, useState } from 'react';
import { FilterChip, getBoundaryLabel } from '@marqvision/shared';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { NumberRangePicker } from '../Dashboard/components/NumberRangePicker';
import { useGetFilterParams, usePathParams } from './@hooks';

export const SalesVolumeFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams, removeParams } = useGetFilterParams();
  const { min_sales_volume: minSalesVolume, max_sales_volume: maxSalesVolume } = requestFilterParams;

  const [salesVolumeAnchorEl, setSalesVolumeAnchorEl] = useState<HTMLElement | null>(null);

  const { page, listingStatus } = usePathParams();
  const { amplitudeLogging } = useLogger();
  const handleApply = (newMinSalesVolume: number | null, newMaxSalesVolume: number | null) => {
    const isResetValue =
      (newMinSalesVolume === null && newMaxSalesVolume === null) ||
      (newMinSalesVolume === 0 && newMaxSalesVolume === 0);

    if (isResetValue) {
      removeParams(['min_sales_volume', 'max_sales_volume']);
    } else {
      const params: Record<string, number | undefined> = {};
      if (newMinSalesVolume !== null) {
        params.min_sales_volume = newMinSalesVolume;
      }
      if (newMaxSalesVolume !== null) {
        params.max_sales_volume = newMaxSalesVolume;
      }

      setParams(params);

      amplitudeLogging('applied filter', {
        Type: 'sales volume',
        Channel: page, // marketplace, social media..
        Page: getListingTabGroup(listingStatus), // scanned, flagged, in progress, case closed, test purchase
      });
    }
  };

  return (
    <>
      <FilterChip
        size={size}
        type="other"
        selected={getBoundaryLabel(minSalesVolume, maxSalesVolume)?.name}
        label="Sales volume"
        onClick={(e: SyntheticEvent<HTMLElement>) => setSalesVolumeAnchorEl(e.currentTarget)}
      />
      {salesVolumeAnchorEl && (
        <NumberRangePicker
          anchorEl={salesVolumeAnchorEl}
          min={minSalesVolume || 0}
          max={maxSalesVolume || 0}
          format="number"
          onApply={handleApply}
          onClose={() => setSalesVolumeAnchorEl(null)}
        />
      )}
    </>
  );
};
